import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { AuthService } from 'app/um/services/auth-service';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class DuplicateServiceAuthsGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull
    public authId: string | null = null;
    @bindable.boolean
    public isDental: boolean = false;

    protected duplicateAuths: UM.Auth[] | undefined = undefined;

    protected pageSize: number = 5;
    protected authResultCount: number = 0;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(private readonly authService: AuthService,
        ...rest: any[]) {

        super(...rest);
    }


    ////****************** Events ***************************************************////


    /****************** Functions **********************************************/
    public async openServicesDuplicatedAuths() {
        if(!this.duplicateAuths) await this.loadServicesDuplicatedAuths();
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    public async loadServicesDuplicatedAuths() {
        if(!this.authId) return;

        const options: Partial<IQueryLoadOptions> = {
            top: this.pageSize,
            page: this.$pager?.page || 0,
            includeInactive: false
        };

        try {
            this.state.beginLoad();

            const includes = [
                'services.definition',
                'services.definition.type.bodySiteType',
                'services.status',
                'status'
            ];

            const fields = [
                'number',
                'serviceDate.dateRange.start',
                'services.definition.code',
                'services.definition.description',
                'services.definition.type.bodySiteType.code',
                'services.status.description',
                'status.description'
            ];

            if(this.isDental) {
                includes.push('services.bodySite', 'services.bodySubSite');
                fields.push('services.bodySite.description', 'services.bodySubSite.description');
            }

            const responseAuthsbyServices = await this.authService.loadDuplicateAuthsByService(this.authId, this.isDental, options, includes, fields);
            const rawDuplicateServicesAuths = responseAuthsbyServices.results;
            this.authResultCount = responseAuthsbyServices.count || 0;
            rawDuplicateServicesAuths.forEach(sa => {
                sa.services = this.isDental
                    ? sa.services?.filter(s => s.definition?.type?.bodySiteType?.code === 'Dental')
                    : sa.services?.filter(s => !s.definition?.type?.bodySiteType);
            });

            this.duplicateAuths = rawDuplicateServicesAuths;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }

}
